import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CommonService } from 'src/@services/common.service';
import { EndPoints } from 'src/@shared/shared/enum';

@Injectable({
  providedIn: 'root',
})
export class ReportsApiClient {
  constructor(private commonService: CommonService) {}

  getSummary(siteId: string | number): Observable<unknown> {
    return this.commonService.API_GET(`${EndPoints.GetSummary}?siteId=${siteId}`, false);
  }

  getAccountStatements(
    siteId: string | number,
    year: string | number,
    month: string | number
  ): Observable<unknown> {
    return this.commonService.API_GET(
      `${EndPoints.GetAccountStatements}?siteId=${siteId}&StatementYear=${year}&StatementMonth=${month}`,
      false
    );
  }

  getOutstandingInvoices(siteId: string | number): Observable<unknown> {
    return this.commonService.API_GET(
      `${EndPoints.GetOutstandingInvoices}?siteId=${siteId}`,
      false
    );
  }
}
